import { api } from "../../api/client";

export interface Screen {
  id: string;
  key: string;
  route: string;
  title: string;
  requiredPermissions: string[];
  policy: "ALL" | "ANY";
}

export interface MenuItem {
  id: string;
  label: string;
  parentId: string | null;
  screenKey: string | null;
  icon: string | null;
  order: number;
}

interface List<T> { items: T[]; }

export const ScreenApi = {
  list: () => api<List<Screen>>("/screens"),
  create: (body: Omit<Screen, "createdAt" | "createdBy">) =>
    api<Screen>("/screens", { method: "POST", body: JSON.stringify(body) }),
  update: (sid: string, body: Partial<Omit<Screen, "id">>) =>
    api<Screen>(`/screens/${sid}`, { method: "PATCH", body: JSON.stringify(body) }),
  remove: (sid: string) =>
    api<void>(`/screens/${sid}`, { method: "DELETE" }),
};

export const MenuApi = {
  list: () => api<List<MenuItem>>("/menu-items"),
  create: (body: MenuItem) =>
    api<MenuItem>("/menu-items", { method: "POST", body: JSON.stringify(body) }),
  update: (mid: string, body: Partial<Omit<MenuItem, "id">>) =>
    api<MenuItem>(`/menu-items/${mid}`, { method: "PATCH", body: JSON.stringify(body) }),
  remove: (mid: string) =>
    api<void>(`/menu-items/${mid}`, { method: "DELETE" }),
};
